<template>
  <el-image
    :src="imgSrc"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'ImagePreview',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgSrc: null,
      imageApi: this.$config.ctx.iffApi + '/common/image',
      initDownloadApi: this.$config.fileApi.initDownload,
      downloadApi: this.$config.fileApi.download
    };
  },
  methods: {
    /**
     * @description: 初始化获取文件信息
     * @param {*} fileId
     * @return {*}
     */
    initFile (fileId) {
      this.$axios.get(`${this.imageApi}/${fileId}`)
        .then(rsp => {
          this.imgSrc = 'data:image/png;base64,' + rsp.data.data;
        })
        .catch(err => {
          console.error('文件信息加载失败：' + fileId, err);
        });
    }
  },
  watch: {
    value (newValue, oldValue) {
      if (newValue) {
        this.initFile(newValue);
      }
    }
  },
  created () {
    if (this.value) {
      this.initFile(this.value);
    }
  }
};
</script>

<style>

</style>
